<template>
    <div class="login">
        <div class="wrapper">
            <div class="wrapper-logo"><img src="../../assets/img/logo.png"/></div>
            <div class="container">
                <ul class="formNav">
                    <li @click="formNavEvent(0)" :class="formNavIndex===0 ? 'nav-active' : '' ">验证码登录</li>
                    <li @click="formNavEvent(1)" :class="formNavIndex===1 ? 'nav-active' : '' ">密码登录</li>
                </ul>
                <div class="form-item-wrap">
                    <dl class="form-item-label">
                        <img class="phone-icon" src="../../assets/img/icon/phone.png"/>
                        <span>手机号</span>
                    </dl>
                    <dl class="form-item-input">
                        <input type="text" placeholder="请输入手机号码" v-model="mobile"/>
                    </dl>
                    <!-- 验证码登录 -->
                    <div v-show="formNavIndex===0">
                        <dl class="form-item-label">
                            <img class="phone-icon" src="../../assets/img/icon/yanzheng.png"/>
                            <span>验证码</span>
                        </dl>
                        <dl class="form-item-input">
                            <input type="text" placeholder="请输入验证码" v-model="vertification"/>
                            <span class="code-btn" id="getCodeBtn" @click="getCode">获取验证码</span>
                        </dl>
                    </div>
                    <!-- 密码登录 -->
                    <div v-show="formNavIndex===1">
                        <dl class="form-item-label">
                            <img class="phone-icon" src="../../assets/img/icon/pwd.png"/>
                            <span>登录密码</span>
                        </dl>
                        <dl class="form-item-input">
                            <input type="password" placeholder="请输入登录密码" v-model="password"/>
                        </dl>
                    </div>
                    <dl class="form-item-extract"><span @click="$router.push('/register')">注册账号</span></dl>
                    <button class="form-item-btn" @click="login">确定</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                mobile: "",
                vertification: "",
                password: "",
                codeFlag: false,
                formNavIndex: 0
            }
        },
        methods: {
            formNavEvent(index) {
                this.formNavIndex = index;
                this.mobile = "";
                this.vertification = "";
                this.password = "";
            },
            // 获取验证码
            getCode() {
                if (this.codeFlag) {
                    return
                }
                if (!this.mobile) {
                    this.$toast("请输入手机号或邮箱");
                    return;
                }
                this.codeFlag = true;
                let btn = document.getElementById("getCodeBtn");
                let num = 60;
                let t = setInterval(() => {
                    btn.innerHTML = `${num}秒`;
                    num--;
                    if (num <= 0) {
                        this.codeFlag = false;
                        btn.innerHTML = "获取验证码";
                        clearInterval(t);
                    }
                }, 1000);
                let params = {
                    mobile: this.mobile,
                };
                this.ajax.post("appapi/login/sendSmsLoginCode", params).then((res) => {
                    if (res.data.code === 1) {
                        this.$toast(res.data.msg);
                    } else {
                        clearInterval(t);
                        this.codeFlag = false;
                        btn.innerHTML = "获取验证码";
                    }
                })
            },
            login() {
                if (!this.mobile) {
                    this.$toast("请输入手机号");
                    return;
                }
                if (!this.vertification && !this.formNavIndex) {
                    this.$toast("请输入验证码");
                    return;
                }
                let parmas = {
                    mobile: this.mobile,
                    vertification: this.vertification,
                    login_type: this.formNavIndex ? "password" : "code",
                    password: this.formNavIndex ? this.password : "",
                };
                this.ajax.post("appapi/login/login", parmas)
                    .then(res => {
                        console.log("res", res);
                        if (res.data.code === 1) {
                            this.$toast(res.data.msg);
                            sessionStorage.setItem("token", res.data.data.token);
                            this.$router.push({path: "/"});
                        } else {
                            this.$toast(res.data.msg);
                        }
                    });
                console.log(1);
            }
        }
    }
</script>

<style lang='scss'>
    .login {
        .wrapper {
            background: url(../../assets/img/login_background.png) no-repeat 0 0;
            background-size: 100%;
            width: 100%;
            padding: 173px 33px 63px;

            &-logo {
                width: 175px;
                height: 175px;
                margin: 0 auto 130px;
            }
        }

        .container {
            box-shadow: 0 6px 40px 0 rgba(56, 109, 65, 0.12);
            border-radius: 20px;
            box-sizing: border-box;
            background: #F8F8F8;

            .formNav {
                display: flex;
                align-items: center;
                justify-content: space-between;
                overflow: hidden;

                li {
                    flex: 1;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 28px 0 10px;
                    font-size: 30px;
                    font-weight: bold;
                    line-height: 67px;
                    border-radius: 20px 20px 0 0;
                    color: rgba(153, 153, 153, 1);
                    background: #F8F8F8;
                }

                .nav-active {
                    background: #fff;
                    color: #26C472;
                }
            }

            .form-item-wrap {
                padding: 0 30px 48px;
                border-radius: 20px;
                background: #fff;
            }

            .phone-icon {
                width: 21px;
                height: 31px;
            }
        }

        .form-item-btn {
            margin: 30px 0 0;
        }

        .form-item-extract {
            font-size: 28px;
            color: #666666;
            text-align: right;
            font-weight: bold;
            padding: 20px;
        }
    }
</style>
